/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { run } from './run';
import { Identify, SelectAuthenticatorAuthenticate, ChallengeAuthenticator, ReEnrollAuthenticator, RedirectIdp, AuthenticatorEnrollmentData, SelectAuthenticatorEnroll, EnrollAuthenticator, AuthenticatorVerificationData, } from './remediators';
import { AuthenticationFlowMonitor } from './flowMonitors';
const flow = {
    'identify': Identify,
    'select-authenticator-authenticate': SelectAuthenticatorAuthenticate,
    'select-authenticator-enroll': SelectAuthenticatorEnroll,
    'authenticator-enrollment-data': AuthenticatorEnrollmentData,
    'authenticator-verification-data': AuthenticatorVerificationData,
    'enroll-authenticator': EnrollAuthenticator,
    'challenge-authenticator': ChallengeAuthenticator,
    'reenroll-authenticator': ReEnrollAuthenticator,
    'redirect-idp': RedirectIdp
};
export function authenticate(authClient, options) {
    return __awaiter(this, void 0, void 0, function* () {
        const flowMonitor = new AuthenticationFlowMonitor(authClient);
        return run(authClient, Object.assign(Object.assign({}, options), { flow,
            flowMonitor }));
    });
}
